import { menuDiscountCardFactory } from './chunk-KCJDKAN3.mjs';
import { formatMoney } from './chunk-G3WCWBRF.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuDiscountsTableFactory.ts
var menuDiscountsTableFactoryCore = (discounts) => menuDiscountCardFactory(discounts).map((discount) => {
  const menuDiscount = discounts[discount.id];
  return __spreadProps(__spreadValues({}, discount), {
    applyTo: i18n_config_default.t(
      `menuScreen.discountDetails.discountScheme.inputs.applyTo.options.${menuDiscount.applyTo}`
    ),
    discountType: `${i18n_config_default.t(`menuScreen.discountDetails.discountScheme.inputs.discountType.options.${menuDiscount.type}`)} (${menuDiscount.type === "percent" /* PERCENT */ ? `${menuDiscount.value}%` : formatMoney(null, menuDiscount.value)})`,
    taxes: menuDiscount.taxes === "applyBeforeTaxes" /* APPLY_BEFORE */ ? i18n_config_default.t(
      "menuScreen.discountDetails.discountScheme.inputs.taxes.options.applyBefore"
    ) : i18n_config_default.t(
      "menuScreen.discountDetails.discountScheme.inputs.taxes.options.applyAfter"
    ),
    reasonRequired: menuDiscount.requireReason ? i18n_config_default.t("commonTexts.yes") : i18n_config_default.t("commonTexts.no")
  });
});

export { menuDiscountsTableFactoryCore };
